// 引入布局组件
import LayoutIndex from '@/layout/LayoutIndex.vue';

// 定义路由常量
const materialRouter = [
    {
        path: '/material',
        component: LayoutIndex,
        meta: { title: '物料管理', icon: 'material', requireAuth: true },
        name: 'material',
        redirect: '/material',
        children: [
            // 1. 修复的路由：仓库管理 (warehouses.vue)
            {
                path: '/material/materials', // 访问路径
                // 关键修正：路径必须与你实际的 .vue 文件位置完全一致
                component: () => import('@/views/material/material.vue'),
                name: 'material', // 组件名，建议与文件名一致
                meta: { title: '物料管理', requireAuth: false }
            },
            // 1. 修复的路由：仓库管理 (warehouses.vue)
            {
                path: '/material/materialInventory', // 访问路径
                // 关键修正：路径必须与你实际的 .vue 文件位置完全一致
                component: () => import('@/views/material/materialInventory.vue'),
                name: 'materialInventory', // 组件名，建议与文件名一致
                meta: { title: '物料库存', requireAuth: false }
            },
        ]
    }
];

// 导出路由
export default materialRouter;
